var map = {
	"./Admin.svg": 43708,
	"./Alert History.svg": 6023,
	"./BOTs.svg": 99007,
	"./Calendar.svg": 80764,
	"./Feedback.svg": 41820,
	"./Futures Trading Room.svg": 1573,
	"./Logout.svg": 80521,
	"./Picco Trade Ideas.svg": 46165,
	"./Picco Trading Hub.svg": 99424,
	"./Products.svg": 52100,
	"./Profile.svg": 13630,
	"./Settings.svg": 89925,
	"./Stocks & Options Room.svg": 78819
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 62944;